var map = {
	"./AddQualificationModal/AddQualificationModal": 224,
	"./AddQualificationModal/AddQualificationModal.jsx": 224,
	"./AddQualificationModal/Main": 1000,
	"./AddQualificationModal/Main.jsx": 1000,
	"./AdminHomepage/HeroTest": 1001,
	"./AdminHomepage/HeroTest.jsx": 1001,
	"./AdminHomepage/Main": 1002,
	"./AdminHomepage/Main.jsx": 1002,
	"./AdminHomepage/MainContent": 226,
	"./AdminHomepage/MainContent.jsx": 226,
	"./AdminHomepage/Sidebar": 233,
	"./AdminHomepage/Sidebar.jsx": 233,
	"./AvatarUploaderForm/Main": 1702,
	"./AvatarUploaderForm/Main.jsx": 1702,
	"./ChannelDesign/Home": 694,
	"./ChannelDesign/Home.jsx": 694,
	"./ChannelDesign/HomepageSettings": 241,
	"./ChannelDesign/HomepageSettings.jsx": 241,
	"./Discussions/HomepageContainer": 1005,
	"./Discussions/HomepageContainer.jsx": 1005,
	"./Home/ArticleCard": 93,
	"./Home/ArticleCard.jsx": 93,
	"./Home/CureusUCard": 95,
	"./Home/CureusUCard.jsx": 95,
	"./Home/CureusUpdates": 234,
	"./Home/CureusUpdates.jsx": 234,
	"./Home/CureusUpdatesHistoryTable": 1006,
	"./Home/CureusUpdatesHistoryTable.jsx": 1006,
	"./Home/FeaturedContent": 230,
	"./Home/FeaturedContent.jsx": 230,
	"./Home/FeaturedContentCard": 231,
	"./Home/FeaturedContentCard.jsx": 231,
	"./Home/FeaturedContentCarousel": 1007,
	"./Home/FeaturedContentCarousel.jsx": 1007,
	"./Home/FeaturedContentModal": 232,
	"./Home/FeaturedContentModal.jsx": 232,
	"./Home/MetricsCard": 92,
	"./Home/MetricsCard.jsx": 92,
	"./Home/NewsCard": 94,
	"./Home/NewsCard.jsx": 94,
	"./Home/Search": 1008,
	"./Home/Search.jsx": 1008,
	"./Home/VideoImage": 1009,
	"./Home/VideoImage.jsx": 1009,
	"./Home/VideoModal": 243,
	"./Home/VideoModal.jsx": 243,
	"./HomepageFeaturedArticles/Card": 360,
	"./HomepageFeaturedArticles/Card.jsx": 360,
	"./HomepageFeaturedArticles/Content": 244,
	"./HomepageFeaturedArticles/Content.jsx": 244,
	"./HomepageFeaturedArticles/Main": 1010,
	"./HomepageFeaturedArticles/Main.jsx": 1010,
	"./HomepageHeros": 1011,
	"./HomepageHeros.js": 1011,
	"./HomepageHeros/DeleteHeroModal": 229,
	"./HomepageHeros/DeleteHeroModal.jsx": 229,
	"./HomepageHeros/Hero": 228,
	"./HomepageHeros/Hero.jsx": 228,
	"./HomepageHeros/Main": 227,
	"./HomepageHeros/Main.jsx": 227,
	"./NewReviewsDashboard/DashboardKeywordTool": 155,
	"./NewReviewsDashboard/DashboardKeywordTool.jsx": 155,
	"./NewReviewsDashboard/InfoWidget": 165,
	"./NewReviewsDashboard/InfoWidget.jsx": 165,
	"./NewReviewsDashboard/KeywordAutoSuggester": 245,
	"./NewReviewsDashboard/KeywordAutoSuggester.jsx": 245,
	"./NewReviewsDashboard/Main": 1012,
	"./NewReviewsDashboard/Main.jsx": 1012,
	"./NewReviewsDashboard/Reviewership": 246,
	"./NewReviewsDashboard/Reviewership.jsx": 246,
	"./NotificationsCenter/ApprovalEditorOneMatchModal": 100,
	"./NotificationsCenter/ApprovalEditorOneMatchModal.jsx": 100,
	"./NotificationsCenter/ApprovalEditorResubmittedModal": 101,
	"./NotificationsCenter/ApprovalEditorResubmittedModal.jsx": 101,
	"./NotificationsCenter/ChannelAdminReviewArticlesModal": 102,
	"./NotificationsCenter/ChannelAdminReviewArticlesModal.jsx": 102,
	"./NotificationsCenter/CollectionApplicationApprovalModal": 103,
	"./NotificationsCenter/CollectionApplicationApprovalModal.jsx": 103,
	"./NotificationsCenter/GuestEditorModal": 104,
	"./NotificationsCenter/GuestEditorModal.jsx": 104,
	"./NotificationsCenter/Main": 105,
	"./NotificationsCenter/Main.jsx": 105,
	"./NotificationsCenter/ReviewerModal": 106,
	"./NotificationsCenter/ReviewerModal.jsx": 106,
	"./PicturePrognosisHome/AnswerBarRow": 130,
	"./PicturePrognosisHome/AnswerBarRow.jsx": 130,
	"./PicturePrognosisHome/AnswerOption": 171,
	"./PicturePrognosisHome/AnswerOption.jsx": 171,
	"./PicturePrognosisHome/AnswerOutcome": 250,
	"./PicturePrognosisHome/AnswerOutcome.jsx": 250,
	"./PicturePrognosisHome/Clarification": 251,
	"./PicturePrognosisHome/Clarification.jsx": 251,
	"./PicturePrognosisHome/Landing": 1014,
	"./PicturePrognosisHome/Landing.jsx": 1014,
	"./PicturePrognosisHome/Widget": 287,
	"./PicturePrognosisHome/Widget.jsx": 287,
	"./UserProfile": 1727,
	"./UserProfile.js": 1727,
	"./UserProfile/Biography": 1728,
	"./UserProfile/Biography.jsx": 1728,
	"./UserProfile/ContentCard": 697,
	"./UserProfile/ContentCard.jsx": 697,
	"./UserProfile/Main": 1729,
	"./UserProfile/Main.jsx": 1729,
	"./UserProfile/SiqHover": 1730,
	"./UserProfile/SiqHover.jsx": 1730,
	"./UserProfileModals": 1731,
	"./UserProfileModals.js": 1731,
	"./UserProfileModals/AffiliationsMain": 886,
	"./UserProfileModals/AffiliationsMain.jsx": 886,
	"./UserProfileModals/AffiliationsRow": 887,
	"./UserProfileModals/AffiliationsRow.jsx": 887,
	"./UserProfileModals/EditAboutMe": 888,
	"./UserProfileModals/EditAboutMe.jsx": 888,
	"./UserProfileModals/EditInstitutionalEmail": 889,
	"./UserProfileModals/EditInstitutionalEmail.jsx": 889,
	"./UserProfileModals/EditProfile": 890,
	"./UserProfileModals/EditProfile.jsx": 890,
	"./UserProfileModals/Main": 1732,
	"./UserProfileModals/Main.jsx": 1732,
	"./UserProfileModals/Npi": 892,
	"./UserProfileModals/Npi.jsx": 892,
	"./UserProfileModals/NpiEdit": 893,
	"./UserProfileModals/NpiEdit.jsx": 893,
	"./UserProfileModals/NpiOther": 894,
	"./UserProfileModals/NpiOther.jsx": 894,
	"./UserProfileModals/NpiRegistered": 896,
	"./UserProfileModals/NpiRegistered.jsx": 896,
	"./UserProfileModals/NpiRows": 194,
	"./UserProfileModals/NpiRows.jsx": 194,
	"./UserProfileModals/NpiUs": 895,
	"./UserProfileModals/NpiUs.jsx": 895,
	"./UserProfileModals/PeerReviewPanel": 897,
	"./UserProfileModals/PeerReviewPanel.jsx": 897,
	"./UserProfileModals/PhoneNumber": 891,
	"./UserProfileModals/PhoneNumber.jsx": 891,
	"./UserProfileModals/PublicProfile": 898,
	"./UserProfileModals/PublicProfile.jsx": 898,
	"./UsersPage/Activities": 1733,
	"./UsersPage/Activities.jsx": 1733,
	"./UsersPage/Coauthors": 1734,
	"./UsersPage/Coauthors.jsx": 1734
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2165;